import { useMemo } from 'react';
import { useFormContext } from 'react-hook-form';

import { FOR_BANK_SECTIONS, FOR_BANK_SUB_SECTIONS } from 'constants/businessToolSections/forBank';
import { debounce } from 'lodash';

import useCheckSubSectionAccess from 'hooks/useCheckSubSectionAccess';

import { PERIODS_OPERATION_TYPES, summarizeSubtractPeriodValues } from 'components/BusinessToolForm/utils/helpers';

import { observedFields } from '../../utils/form';

export const useGetTotalInIndirectNetCashCalculation = () => {
  const { setValue } = useFormContext();

  const canAccess = useCheckSubSectionAccess(
    FOR_BANK_SECTIONS.MARKETING_AND_SALES,
    FOR_BANK_SUB_SECTIONS.FOR_BANK_MARKETING_AND_SALES.SALES_PLAN,
  );

  const [totalIndirectNetCashFiled] = observedFields.totalIndirectNetCash.setCalculatedValueFieldNames;

  const getTotalIndirectNetCashCalculationHandler = useMemo(
    () =>
      debounce((content) => {
        if (!canAccess) return;
        const [
          netIncome,
          deprecationAmortization,
          gainLosesAssets,
          deferredTaxes,
          accountsReceivable,
          inventories,
          accountsPayable,
          otherOperatingAssets
        ] = content;
        const sumOfTotalIndirect = summarizeSubtractPeriodValues(
          [netIncome, deprecationAmortization, gainLosesAssets, deferredTaxes, accountsPayable, otherOperatingAssets],
          PERIODS_OPERATION_TYPES.ADD,
        );
        
        const totalIndirectNetCash = summarizeSubtractPeriodValues(
          [
            sumOfTotalIndirect,
            accountsReceivable,
            inventories,
          ],
          PERIODS_OPERATION_TYPES.SUBTRACT,
        );
      
        setValue(totalIndirectNetCashFiled, totalIndirectNetCash); 
      }, 700),
     
    [],
  );

  return getTotalIndirectNetCashCalculationHandler;
};
